import React, { memo, useEffect, useState, useRef } from "react";
import { Separator, SidebarContent, Accordion } from "@/components/ui";
import { Header } from "./Header";
import { FilterGroup } from "./FilterGroup";
import { useScrolledToBottom } from "./hooks/useScrolledToBottom";
import { ScrollDownIndicator } from "./ScrollDownIndicator";
import { useSearchFilterGroups } from "./hooks/useSearchFilterGroups";
import { FilterGroup as FilterGroupType } from "./types";
import { FiltersSkeleton } from "./FiltersSkeleton";
import { useLocation } from "react-router-dom";

export const SearchableFilters = memo(function SearchableFilters({
  filterGroups,
  loading = false,
}: {
  filterGroups: FilterGroupType[] | null;
  loading?: boolean;
}) {
  const [filterText, setFilterText] = useState<string>("");
  const contentRef = useRef<HTMLDivElement>(null);
  const scrolledToBottom = useScrolledToBottom(contentRef);
  const filteredFilters = useSearchFilterGroups(filterText, filterGroups);
  const location = useLocation();

  const [openedGroups, setOpenedGroups] = useState<string[] | null>(null);

  useEffect(() => {
    if (filteredFilters && filteredFilters.length > 0)
      setOpenedGroups([filteredFilters[0].title]);
  }, [filteredFilters, location]);

  function renderFilterList() {
    if (loading) return <FiltersSkeleton />;

    return (
      openedGroups !== null && (
        <Accordion
          type="multiple"
          value={openedGroups}
          onValueChange={setOpenedGroups}
        >
          {filteredFilters?.map((group) => (
            <FilterGroup key={group.title} group={group} />
          ))}
        </Accordion>
      )
    );
  }

  return (
    <>
      <Header
        onSearchInputUpdate={(text) => setFilterText(text)}
        onCollapseFilterGroups={() => setOpenedGroups([])}
        collapseButtonDisabled={loading}
      />
      <Separator />
      <div className="relative flex min-h-0 flex-1 flex-col">
        <SidebarContent ref={contentRef}>
          <div className="z-1 flex flex-col">
            {renderFilterList()}
            <ScrollDownIndicator isHidden={scrolledToBottom} />
          </div>
        </SidebarContent>
      </div>
      <Separator />
    </>
  );
});
